import type { InsightPatientRow } from "src-next/modules/clinical-insights/types/insightWorkspaceTypes";

export function patientHasPhone(patient?: fhir5.Patient): boolean {
  return Boolean(
    patient?.telecom?.some(
      (entry) => entry.system === "phone" && String(entry.value ?? "").trim()
    )
  );
}

export function latestItemDate(items: InsightPatientRow["items"]): string {
  if (items.length === 0) return "—";
  return items.reduce((best, item) => {
    const t = Date.parse(item.date);
    const bestT = Date.parse(best);
    if (Number.isNaN(t)) return best;
    if (Number.isNaN(bestT) || t > bestT) return item.date;
    return best;
  }, items[0].date);
}

/** Situação dominante do paciente — chip curto na tabela; detalhes no tooltip. */
export function buildPatientSituationChip(
  items: InsightPatientRow["items"],
  statusLabelByKey: Record<string, string>,
  noItemsTooltip: string,
  itemPlural: string
): { chipLabel: string; tooltip: string; statusKey: string } {
  if (items.length === 0) {
    return { chipLabel: "—", tooltip: noItemsTooltip, statusKey: "aberta" };
  }
  const counts = items.reduce<Record<string, number>>((acc, item) => {
    acc[item.statusKey] = (acc[item.statusKey] ?? 0) + 1;
    return acc;
  }, {});
  const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  const [topKey, topCount] = sorted[0];
  const chipLabel =
    statusLabelByKey[topKey] ??
    topKey.charAt(0).toUpperCase() + topKey.slice(1);
  const tooltip = sorted
    .map(([key, count]) => {
      const name =
        statusLabelByKey[key] ?? key.charAt(0).toUpperCase() + key.slice(1);
      return `${count} ${name.toLowerCase()}`;
    })
    .join(" · ");
  const extra =
    sorted.length > 1 ? ` (${topCount}/${items.length} ${itemPlural})` : "";
  return {
    chipLabel,
    tooltip: `${tooltip}${extra}`,
    statusKey: topKey,
  };
}
